<template>
  <section>
    <div class="p_m_container">
      <div class="p_m_menu" id="_left_menu">
        <div class="model_tree_left_c" id="_left_menu_c">
          <ActorTree :data="data" :model-id="tokenId" @actorCheck="actorCheck" ref="actorTree"></ActorTree>
        </div>
      </div>
      <div class="p_m_main">
        <div class="p_m_engine">
          <div id="engineContainer">
              <ModelToolBar :mode="mode" :tokenId="tokenId" ref="toolbar" class="e_toolbar"></ModelToolBar>
              <div id="voidLoad"><div class="void_loading">模型加载中...<i class="el-icon-loading"></i></div></div>
          </div>
        </div>
        <div class="p_m_progress">
            <Gantt :data="data" :model-id="tokenId" :scheduledId="scheduledId" :pro-id="proId"></Gantt>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

  import ModelToolBar from "../model/ModelToolBar";
  import ActorTree from "../model/ActorTree";
  import Gantt from "./Gantt";

  export default {
    name: "Engine",
    components: {Gantt, ActorTree, ModelToolBar},
    props: {
      data: {},
    },
    data() {
      return {
        //mode: 'vertical',//horizontal
        mode:'horizontal',
        tokenId: null,
        scheduledId:null,
        proId:null,
      }
    },
    methods: {
      actorCheck: function () {
        this.$refs.toolbar.doManageMode(2);
      },
      moveLeftMenu: function (e) {
        $(document).bind("mousemove", this.mouseMove).bind("mouseup", this.mouseUp)
      },
      mouseMove: function (e) {

        if (e.clientX > 251) {
          $("#_left_menu").css("width", e.clientX - 20 + 'px')
          $("#_left_menu_c").css("width", e.clientX - 25 + 'px')
        } else {
          this.mouseUp();
        }

      },
      mouseUp: function () {
        $(document).unbind("mousemove", this.mouseMove).unbind("mouseup", this.mouseUp);
      }
    },
    created(){
      this.tokenId = this.GLOBAL.getURLParam('modelId');
      this.file = this.GLOBAL.getURLParam('file');
      this.scheduledId = this.GLOBAL.getURLParam('scheduledId');
      this.proId =  this.GLOBAL.getURLParam('proId');
      this.scheduledName = this.GLOBAL.getURLParam("scheduledName");
    },
    mounted() {
      EngineInit("engineContainer");	// 加载模型
      AddModel("http://121.40.229.90:83/" + this.file + "/" + this.file + "List.json", this.tokenId, true);
      //SetClickMode(0);
      this.$refs.toolbar.doManageMode(2);
      SetKeyBoardEnable(false);
    },
    destroyed() {
      //ClearScene();
      hasSelectionIds = [];
      searchProperty = false;
    }
  }
</script>

<style scoped>
  .p_m_container {
    height: 750px;
    position: relative;
    width: 100%;
    display: table;

  }
  .p_m_menu {
    width: 251px;
    height: 100%;
    display: table-cell;
    position: relative;
    border-left: 1px solid #c9c9c9;
    border-bottom: 1px solid #c9c9c9;
  }
  .p_m_main {
    position: relative;
    height: 100%;
    display: table-cell;
  }

  .p_m_engine {
    position: absolute;
    width: 100%;
    height: 60%;
    top: 0px;
    left: 0px;
  }
  .p_m_progress {
    position: absolute;
    width: 100%;
    height: 40%;
    bottom: 0px;
    left: 0px;

  }

  /*===================================*/
  .model_tree_left_c {
    width: 251px;
    height: 100%;
  }
  #engineContainer {
    position: relative;
    width: 100%;
    height: 100%;
  }
  /*工具栏*/
  .e_toolbar {
    position: absolute;
    top: 20px;
    right: 20px;
  }
#voidLoad{position: absolute;top: 0px;left: 0px; width: 100%; height: 100%;display: none; text-align: center;}
.void_loading{position: absolute;top: 255px;width: 100%; text-align: center;}
</style>



// WEBPACK FOOTER //
// src/components/progress/EngineView.vue